/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable no-unused-vars */
import React from 'react';
import "./HomePage.css"
import images from '../../Asset/Img/img';
import { Link } from 'react-router-dom';
import data from "../../Data/data"

function HomePage() {
  return (
    <div className='home-container'>
      <div className="home-content">
        {/*Home header start*/}
        <div className="home-header">
          <div className='header-text'>
            <p>Compounding Excellence </p>
          </div>
          <a href={data.hpcData} title="PDF DOSYASI İNDİR" className='certifica-img' target="_blank" download={true}>
            <img src={images.qualityIsoIcon} alt="certifica" />
          </a>
        </div>

        {/*Home header end*/}

        {/*Who are we section start*/}

        <div className='home-our'>

          <div className='our-text'>
            <h3>BİZ KİMİZ ?</h3>
            <p>High Performance Compounds Kauçuk A.Ş. Bursa Hasanağa Sanayi Bölgesi’nde 2016 yılında kurulmuştur. High PCK, Ligom S.p.A. şirketinin dahil olduğu TSF S.p.A grubunun (İtalya) bir parçasıdır.</p>
            <Link to='/about'>Detaylı bilgi için tıklayın <img src={images.detailBtnIcon} alt="detail-icon" /></Link>
          </div>

          <div className='our-header'>
              <h2>ÜRÜMLERİMİZ</h2>
          </div>

          <div className='our-img-box'>
            <div>
              <p>SIZDIRMAZLIK TEKNOLOJİSİ KAUÇUK HAMURLARI</p>
            </div>
            <div>
              <p>TİTREŞİM ÖNLEME TEKNOLOJİSİ KAUÇUK HAMURLARI</p>
            </div>
            <div>
              <p>İÇEME SUYU UYUMLU KAUÇUK HAMURLARI</p>
            </div>
            <div>
              <p>YANMAZ HAMUR KARIŞIMLARI</p>
            </div>
            <div>
              <p>ÖZEL VE İHTİYACA YÖNELİK KAUÇUK HAMURLARI</p>
            </div>

          </div>

        </div>


        {/*Who are we section end*/}

        {/* Compatibility start */}
        <div className='home-compatibility'>
          <div className='compat-content'>
            <h3>Uyumlu Olduğumuz Bazı Normlar</h3>

            <div className='compat-click-active'>

              <div>
                <img src={images.tickBoxIcon} alt="tick" />
                <p>EN 45545</p>
              </div>

              <div>
                <img src={images.tickBoxIcon} alt="tick" />
                <p>EN549 A2 H2 Diaphramgs</p>
              </div>

              <div>
                <img src={images.tickBoxIcon} alt="tick" />
                <p>EN 681 WA</p>
              </div>

              <div>
                <img src={images.tickBoxIcon} alt="tick" />
                <p>VW 2.8.1</p>
              </div>

            </div>

            <div className='brand'>
              <img src={images.bmw} alt="bmw" />
              <img src={images.bosch} alt="bosch" />
              <img src={images.fca} alt="Fca" />
              <img src={images.hella} alt="hella" />
              <img src={images.kiwa} alt="kiwa" />
              <img src={images.manIcon} alt="man-icon" />
              <img src={images.nsf} alt="Nsf" />
              <img src={images.porsche} alt="porsche" />
              <img src={images.scania} alt="scania" />
              <img src={images.ul} alt="UL" />
              <img src={images.volkswagen} alt="wolkswagen" />
              <img src={images.wras} alt="wras" />
            </div>

          </div>
        </div>

        {/* Compatibility end */}


        {/* Announcements start */}
        <div className='home-announcements'>

          <h3>DUYURULAR</h3>
          <div className='announcements-box-container'>
            <div className='announcements-box-one'>
              <div className='announcements-content-header-box'>
                <p>Web Sitemiz Yenilendi</p>
                <p>01.12.2022</p>
              </div>

              <p>Aliquam a dui vel justo fringilla euismod id id enim. Nunc non semper tellus. Pellentesque vitae tellus non dui fermentum hendrerit. In vel imperdiet mi. Aliquam erat volutpat. Cras dapibus orci eu eros tempus efficitur.
              </p>

              <p> Nulla rhoncus arcu nec dictum condimentum. Aenean sapien leo, maximus nec magna vel, gravida auctor quam.  Aliquam a dui vel justo fringilla euismod id id enim. Nunc non semper tellus. Pellentesque vitae tellus non dui fermentum hendrerit. In vel imperdiet mi. Aliquam erat volutpat. Cras dapibus orci eu eros tempus efficitur.</p>

              <p> Nulla rhoncus arcu nec dictum condimentum. Aenean sapien leo, maximus nec magna vel, gravida auctor quam.  Nulla rhoncus arcu nec dictum condimentum. Aenean sapien leo, maximus nec magna vel, gravida auctor quam. Aenean sapien leo, maximus nec magna vel, gravida auctor quam.</p>

            </div>

            <div className='announcements-box-two'>
              <div className='announcements-content-header-box'>
                <p>Web Sitemiz Yenilendi</p>
                <p>01.12.2022</p>
              </div>

              <p>Aliquam a dui vel justo fringilla euismod id id enim. Nunc non semper tellus. Pellentesque vitae tellus non dui fermentum hendrerit. In vel imperdiet mi. Aliquam erat volutpat. Cras dapibus orci eu eros tempus efficitur.
              </p>

              <p> Nulla rhoncus arcu nec dictum condimentum. Aenean sapien leo, maximus nec magna vel, gravida auctor quam.  Aliquam a dui vel justo fringilla euismod id id enim. Nunc non semper tellus. Pellentesque vitae tellus non dui fermentum hendrerit. In vel imperdiet mi. Aliquam erat volutpat. Cras dapibus orci eu eros tempus efficitur.</p>

              <p> Nulla rhoncus arcu nec dictum condimentum. Aenean sapien leo, maximus nec magna vel, gravida auctor quam.  Nulla rhoncus arcu nec dictum condimentum. Aenean sapien leo, maximus nec magna vel, gravida auctor quam. Aenean sapien leo, maximus nec magna vel, gravida auctor quam.</p>

            </div>
          </div>
        </div>

        {/* Announcements end */}

      </div>
    </div>
  )
}

export default HomePage
